
import ProductView from '@/components/Shop/ProductView';
import Breadcrumbs from '@/components/Shop/Breadcrumbs.vue';
import user_mixin from '@/mixins/user_mixin';
import { trackEvent } from '@/lib/clevertap';
import { mapMutations, mapState } from 'vuex';

export default {
  layout(context) {
    return context.$auth.loggedIn ? 'parents' : 'home';
  },
  components: {
    ProductView,
    Breadcrumbs
  },
  mixins: [user_mixin],
  data() {
    return {
      loading: false,
      product: null,
      variantId: null
    };
  },
  computed: {
    ...mapState('general', ['childProfileHash']),
    ...mapState('global', ['unregisteredUserId']),
    targetProfileId() {
      if (this.$auth?.loggedIn)
        return this.childProfileHash?.targetProfileId;
      else
        return null;
    },
    isMobile() {
      return this.$vuetify.breakpoint.xs;
    }
  },
  async fetch() {
    console.log('products/id fetch start -------');
    try {
      await this.getProductDetails();
    } catch (err) {
      console.log('products/id fetch error ----- ', err)
    }
    console.log('products/id fetch end -------');
  },
  head() {
    // if (!this.product?.defaultVariant) return {};
    console.log('products/id set header start -------');
    const variant =
      this.product?.variations?.find(el => el.id === this.variantId) ??
      this.product?.variation;
    if (!variant) return {};
    const extraAttr = JSON.parse(variant.extraAttr);
    console.log('products/id set header end -------', variant?.meta_description,variant?.page_title,variant?.meta_description, extraAttr?.defaultImg?.path );
    return {
      title: variant.page_title,
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: variant.meta_description
        },
        {
          hid: 'og:title',
          property: 'og:title',
          content: variant.page_title
        },
        {
          hid: 'og:description',
          property: 'og:description',
          content: variant.meta_description
        },
        {
          hid: 'og:image',
          property: 'og:image',
          content: `${this.$config.API_URL}/${extraAttr?.defaultImg?.path}`
        },
        {
          hid: 'og:url',
          property: 'og:url',
          content: `${this.$config.DOMAIN_NAME}${this.$nuxt.$route.path}`
        },
        {
          hid: 'og:site_name',
          property: 'og:site_name',
          content: 'BraingGymJr'
        }
      ],
      script: [
        {
          type: 'application/ld+json',
          json: {
            '@context': 'https://schema.org/',
            '@type': 'Product',
            name: variant.page_title,
            description: variant.meta_description,
            image:
              extraAttr.images.map(
                el => `${this.$config.API_URL}/${el.path}`
              ) ?? [],
            brand: {
              '@type': 'Brand',
              name: this.product?.brand?.name
            },
            offers: {
              '@type': 'Offer',
              price:
              extraAttr.countryPricing[this.$auth?.user?.shopCountry?.id ?? 81]
                .offer_price,
              priceCurrency: this.$auth?.user?.shopCountry?.currency ?? 'INR',
              availability: 'https://schema.org/InStock'
            }
          }
        }
      ]
    };
  },
  methods: {
    ...mapMutations('general', ['setOffer', 'setBrand', 'setCategory']),
    async getProductDetails() {
      console.log('products/id get product fun. start -------');
      this.loading = true;
      const isProductId = /^\d+$/.test(this.$route.params.id);
      let productId;
      let variantId;
      if (isProductId) {
        productId = this.$route.params.id;
      } else {
        console.log('products/id get product id from url api start -------');
        const resp = await this.$api.shop.find({
          items: 'products',
          url: this.$route.params.id
        });
        console.log('products/id get product id from url api end -------');
        productId = resp?.productId;
        this.variantId = resp?.variantId;
      }
      if (this.$route.query.variantId)
        this.variantId = parseInt(this.$route.query.variantId);

      try {
        console.log('products/id get product detail api start -------');
        this.product = await this.$api.shop.find({
          items: 'products',
          productId,
          childId: this.getChild?.id,
          targetProfileId: this.targetProfileId
        });
        console.log('products/id get product detail api end -------');
        if (this.$auth?.loggedIn) {
          console.log('products/id track popularity api start -------');
          await this.$api.shop.find({
            items: 'trackPopularity',
            variantId: this.variantId,
            parentId: this.$auth?.user?.id,
            childId: this.getChild?.id,
            userId: this.unregisteredUserId
          });
          console.log('products/id track popularity api end -------');
        }
      } catch (e) {
        console.log('product detail api error ', e)
      } finally {
        this.loading = false;
      }
      console.log('products/id get product fun. end -------');
    },
    trackVariantSelection({ event, payload }) {
      if (this.$auth.loggedIn)
        trackEvent(event, {
          platform: 'web',
          productId: this.product.id,
          productName: this.product.name,
          brandId: this.product.brand_id,
          brand: this.product.brand ? this.product.brand.name : null,
          category: this.product.category ? this.product.category.name : null,
          categoryId: this.product.category_id,
          vendor: '',
          ...payload,
          childId: this.getChild.id,
          childName: this.getChild.name
        });
    }
  },
  destroyed() {
    this.setOffer(null);
    this.setBrand(null);
    this.setCategory(null);
  },
  async beforeRouteEnter(to, from, next) {
    next(async vm => {
      await vm.getProductDetails();
    }); // Call next() to proceed with entering the route
  }
};
